/**
 * Latest GPS status for a roster entry.
 * Prefers the details-view `gpsData` summary, otherwise the last `gpsPings` item.
 * Returns null when there is no ping or `onsite` is missing.
 *
 * @param {{ gpsData?: { onsite?: boolean, timestamp?: number }, gpsPings?: Array<{ onsite?: boolean, timestamp?: number }> }} placement
 * @returns {{ onsite: boolean, timestamp?: number } | null}
 */
const latestGpsStatus = (placement) => {
  const pings = placement?.gpsPings;
  const lastPing = Array.isArray(pings) && pings.length > 0 ? pings[pings.length - 1] : undefined;
  const gps = placement?.gpsData ?? lastPing;

  if (gps == null || gps.onsite == null) {
    return null;
  }

  return {
    onsite: gps.onsite,
    timestamp: gps.timestamp,
  };
};

export default latestGpsStatus;
